import {Box} from '@mantine/core';
import React from 'react';

import {maybeGetValueFromConfig} from 'pipelines/generalized-step-config-editor/step-config-settings/StepConfigSettingsUtils';
import {
  ConfigShapePath,
  CustomComponentEditorProps,
} from 'pipelines/generalized-step-config-editor/StepConfigEditorTypes';
import getTestProps from 'test/lib/cypress/getTestProps';
import SearchableUnitDropdown, {SearchableUnitDropdownProps} from 'units/SearchableUnitDropdown';

interface UnitSelectEditorProps extends CustomComponentEditorProps {
  configShapePath: ConfigShapePath;
  unitTypeFilter: SearchableUnitDropdownProps['unitTypeFilter'];
}

export default function UnitSelectEditor({
  config,
  configShapePath,
  disabled,
  onChangeConfig,
  unitTypeFilter,
}: UnitSelectEditorProps): JSX.Element {
  const configValue = maybeGetValueFromConfig(config, configShapePath);
  const selectedId = typeof configValue === 'string' ? configValue : null;

  return (
    <Box {...getTestProps({component: 'UnitSelectEditor', element: 'root'})}>
      <SearchableUnitDropdown
        disabled={disabled}
        includeNone={true}
        onSelect={(unit) => {
          onChangeConfig(config, configShapePath, unit?.id ?? null);
        }}
        selectedId={selectedId}
        unitTypeFilter={unitTypeFilter}
      />
    </Box>
  );
}
